import { useContext } from "react";
import { loadingContext } from "@/app/store/context/isLoadingContext";
import { useRouter, usePathname, useSearchParams } from "next/navigation"
import { screenSizeContext } from "../store/context/screenSizesContext";

export const useNavigation = () => {
  const {setIsPageFetched} = useContext(loadingContext);
  const router = useRouter();
  const pathname = usePathname();
  const params = useSearchParams();
  const { isIpad } = useContext(screenSizeContext);

  return {
    push: (url: string, extraQueryParam?: string)=> {
      const queryString = params.toString();
      let newUrl: string;
      
      // Determine if this is a same-page navigation (adding query params to current page)
      const isSamePage = url === pathname;
      const isSamePageWithQuery = extraQueryParam && isSamePage;
      
      if (!isSamePage) {
        if(!isIpad) window.lenis?.stopScroll?.(true);
        else document.documentElement.style.overflow = "hidden";
        setIsPageFetched("loading");
      }
      
      // Handle query parameters
      if (extraQueryParam) {
        if (queryString && !queryString.includes(extraQueryParam)) {
          newUrl = `${url}?${queryString}&${extraQueryParam}`;
        } else if (queryString && queryString.includes(extraQueryParam)) {
          newUrl = `${url}?${queryString}`;
        } else {
          newUrl = `${url}?${extraQueryParam}`;
        }
      } else {
        // Don't preserve query params when navigating to a different page without extraQueryParam
        newUrl = url;
      }

      // Navigate immediately if same page with query, otherwise use loading delay
      if (isSamePageWithQuery) {
        // Same page, just add/update query param - navigate immediately
        router.push(newUrl);
      } else if (newUrl !== pathname) {
        // Different page - use loading animation delay
        setTimeout(() => router.push(newUrl), 1700);
      }
    }
  }
}